/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import { IconProps } from "../types";
const CautionCircleIcon = ({
  size = 24,
  ...props
}: IconProps) => {
  return <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width={size} height={size} {...props}><path fillRule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25m-1.35 13.875a1.375 1.375 0 1 1 2.75 0 1.375 1.375 0 0 1-2.75 0m2.63-3.375a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-5.5a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 .75.75z" clipRule="evenodd" /></svg>;
};
export default CautionCircleIcon;